import { render } from "./CustomCascader.vue?vue&type=template&id=a0fe9ef8"
import script from "./CustomCascader.vue?vue&type=script&lang=js"
export * from "./CustomCascader.vue?vue&type=script&lang=js"

import "./CustomCascader.vue?vue&type=style&index=0&id=a0fe9ef8&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__